export default {
    props: {
        titleAlign: {
            type: String,
            kComposite: 'title.align'
        }, 
        titleBackground: {
            type: String,
            kComposite: 'title.background'
        }, 
        titleBorderColor: {
            type: String,
            kComposite: 'title.border.color'
        }, 
        titleBorderDashType: {
            type: String,
            kComposite: 'title.border.dashType'
        }, 
        titleBorderWidth: {
            type: Number,
            kComposite: 'title.border.width'
        }, 
        titleColor: {
            type: String,
            kComposite: 'title.color'
        }, 
        titleFont: {
            type: String,
            kComposite: 'title.font'
        }, 
        titleMargin: {
            type: Number,
            kComposite: 'title.margin'
        }, 
        titleMarginBottom: {
            type: Number,
            kComposite: 'title.margin.bottom'
        }, 
        titleMarginLeft: {
            type: Number,
            kComposite: 'title.margin.left'
        }, 
        titleMarginRight: {
            type: Number,
            kComposite: 'title.margin.right'
        }, 
        titleMarginTop: {
            type: Number,
            kComposite: 'title.margin.top'
        }, 
        titlePadding: {
            type: Number,
            kComposite: 'title.padding'
        }, 
        titlePaddingBottom: {
            type: Number,
            kComposite: 'title.padding.bottom'
        }, 
        titlePaddingLeft: {
            type: Number,
            kComposite: 'title.padding.left'
        }, 
        titlePaddingRight: {
            type: Number,
            kComposite: 'title.padding.right'
        }, 
        titlePaddingTop: {
            type: Number,
            kComposite: 'title.padding.top'
        }, 
        titlePosition: {
            type: String,
            kComposite: 'title.position'
        }, 
        titleText: {
            type: String,
            kComposite: 'title.text'
        }, 
        titleVisible: {
            type: Boolean,
            kComposite: 'title.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Title.js